import { useBackendQuery as useQuery } from "@/hooks/useBackendQuery";

import { IObjectWithTypename } from "@/components/@types";
import { useNode, useNodeSetup } from "@/components/organisms/Node/Node.hooks";
import { Queries } from "@/constants";
import { State } from "@/state";

import { useSettingsEntity } from "./useSettingsEntity";

export function useSettingsEntityNode() {
  const { entity, account } = useSettingsEntity();
  const nodeId = entity?.id;

  const { data, loading: isLoading } = useQuery(Queries.NODE_QUERY, {
    variables: nodeId
      ? {
          id: nodeId,
          startDate: State.getState().timeSeriesFilter.startDate?.toISOString(),
          endDate: State.getState().timeSeriesFilter.endDate?.toISOString(),
        }
      : undefined,
    skip: !nodeId,
  });

  const { store } = useNodeSetup({
    mode: "update",
    node: data?.node as IObjectWithTypename,
    typename: "EntityObject",
  });
  const { actions, metadata } = useNode(store);

  return {
    account,
    actions,
    entity,
    isLoading,
    metadata,
    store,
  };
}
